import { useCallback } from 'react';
import debounce from 'lodash/debounce';

import { useAuth } from '@search/auth/src/useAuth';
import { NewBuilding } from '@search/filter-enums/enums';
import { marketingSendRTB, MarketingRTBRec } from './marketingSendRTB';
import { marketingSendCriteo } from './marketingSendCriteo';

type MarketingParams = {
    type: 'home';
} | {
    type: 'card';
    offerId: string;
} | {
    type: 'search';
    regionId: number;
    offerIds: readonly string[];
    newBuilding?: readonly NewBuilding[];
};

export function useMarketingSend() {
    const { auth } = useAuth();

    const userId = auth.user?.userId;

    const marketingSend = useCallback((props: MarketingParams) => {
        // только при полной загрузке страницы посылаем инфу о offerId и категориях
        if (typeof window === 'undefined') return;

        let p: MarketingRTBRec;

        if (props.type === 'search') {
            const isNewBuilding = props.newBuilding?.includes(NewBuilding.NEW) ?? false;
            const isSecondary = props.newBuilding?.includes(NewBuilding.SECOND) ?? false;
            let category = 'NewBuilding';

            if (isSecondary) category = 'SecondBuilding';
            let categoryId: string | undefined = `${props.regionId}_${category}`;

            // mixed serp
            if (isNewBuilding === isSecondary) categoryId = undefined;

            p = { type: props.type, offerIds: props.offerIds, categoryId, userId };
        } else {
            p = { ...props, userId };
        }

        marketingSendCriteo(p);
        marketingSendRTB(p);
    }, [ userId ]);

    const marketingSendDebounced = useCallback(debounce(marketingSend, 20000));

    return marketingSendDebounced;
}
